export default "__VITE_ASSET__DCrSVgye__"